import axios from 'axios';

const syncListingShowings = async ({
  listingIds,
  appointmentIds,
}: {
  listingIds?: string[];
  appointmentIds?: string[];
}) => {
  const config = {
    url: `/almanac/listing_showings`,
    method: 'post' as const,
    data: {
      listingIds: listingIds?.length ? listingIds : undefined,
      appointmentIds: appointmentIds?.length ? appointmentIds : undefined,
    },
  };

  await axios.request(config);
};

export default syncListingShowings;
